import { useTranslation } from 'react-i18next';
import U2000KeyboardKeyHint from './U2000KeyboardKeyHint';

type U2000AutoCompleteResultKeyboardHintsProps = {
  highlightedIndex: number;
  /** Afficher le pied de page (popup ouvert). */
  showPanel?: boolean;
  /** Namespace i18n pour le libellé Échap (défaut : `common`). */
  escapeHintNs?: string;
  /** Clé i18n pour le libellé Échap (défaut : `keyboardHintClosePanel`). */
  escapeHintLabelKey?: string;
};

/** Barre d'aide sous la grille de résultats d'un popup AutoComplete (Entrée / Échap). */
const U2000AutoCompleteResultKeyboardHints: React.FC<U2000AutoCompleteResultKeyboardHintsProps> = ({
  highlightedIndex,
  showPanel = true,
  escapeHintNs = 'common',
  escapeHintLabelKey = 'keyboardHintClosePanel',
}) => {
  const { t } = useTranslation('common');
  const escapeLabel = t(escapeHintLabelKey, {
    ns: escapeHintNs,
    defaultValue: t('keyboardHintClosePanel'),
  });

  if (!showPanel) {
    return null;
  }

  return (
    <div className="flex shrink-0 flex-wrap gap-x-4 gap-y-0.5 px-1 pt-0.5 text-xs text-gray-500">
      {highlightedIndex >= 0 ? (
        <span className="inline-flex items-center gap-1.5">
          <U2000KeyboardKeyHint>{t('keyboardHintEnterKey')}</U2000KeyboardKeyHint>
          <span>{t('keyboardHintSelectHighlighted')}</span>
        </span>
      ) : null}
      <span className="inline-flex items-center gap-1.5">
        <U2000KeyboardKeyHint>{t('keyboardHintEscapeKey')}</U2000KeyboardKeyHint>
        <span>{escapeLabel}</span>
      </span>
    </div>
  );
};

export default U2000AutoCompleteResultKeyboardHints;
